var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"box pa-5"},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }